module.exports = __webpack_public_path__ + "static/media/down-caret.689bd646.svg";